import { Component, OnInit } from '@angular/core';
import { CommonService } from '../common.service';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.css']
})
export class LogoutComponent implements OnInit {

  constructor(
    private commonService: CommonService
  ) { }

  ngOnInit() {
    console.log("LogoutComponent ngOnInit");
    /* localStorage.removeItem('TEMP_TENDER');
    if (localStorage.getItem('TOKEN')!=null) {
      this.commonService.logout();
    }  */
  }

}
